
// export const ApiUrl = {
//   url: 'https://angulardata.sunwebapps.com/api/',
// };